import React from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { Link } from "react-router-dom";

export const MortgageContractFlow = () => {
  return (
    <div className="body-bg py-5">
      <Container>
        <h2 className="step-head-gray pulse text-center py-3">Have you given anyone a mortgage, contract for deed, land contract or does anyone owe you money (receivables)?</h2>
        <Row className="py-5 justify-content-md-center">
          <Col xs={3} className="text-center">
            <Link to="/dashboard/mortgage-contract">
              <button className="cl-btn-blue big mar-a">Yes, I Do</button>
            </Link>
          </Col>
          <Col xs={3} className="text-center">
            <Link to="/dashboard/real-estate-personal-flow">
              <button className="cl-btn-gray big mar-a">No, I don't</button>
            </Link>
          </Col>
        </Row>
      </Container>
    </div>
  );
};
